<div class="container">
  <div class="close-icon" (click)="closeDialog()">
    <img src="assets/close-icon.svg">
  </div>
  <div class="text-center">
    <div>
      <img src="assets/success-icon.svg">
    </div>
    <div class="dialog-title"><p i18n="@@feedbackSubmitted">Feedback submitted successfully</p></div>
    <p i18n="@@thankYouForFeedback">Thank you for your feedback.</p>
    <primary-button class="done-button" (onClick)="closeDialog()" [enabled]="true" title="{{done}}"></primary-button>
  </div>
</div>
